import { LOCAL_STORAGE_THEME_MODE_KEY } from '../constants/storage'
import {
  THEME,
  THEME_DARK_MEDIA_QUERY,
  THEME_LIGHT_ONLY_PAGE_REG_EXP,
  THEME_MODE,
  THEME_MODE_DEFAULT,
} from '../constants/themeMode'

import { getStorageItem, setStorageItem } from './storage'

export function isThemeDark(theme) {
  return theme === THEME.dark
}

export function getStoredThemeMode() {
  const mode = getStorageItem(LOCAL_STORAGE_THEME_MODE_KEY)

  return Object.values(THEME_MODE).includes(mode) ? mode : THEME_MODE_DEFAULT
}

export function storeThemeMode(mode) {
  setStorageItem(LOCAL_STORAGE_THEME_MODE_KEY, mode)
}

// A `null` key means another tab cleared the whole storage.
export function isThemeModeStorageKey(key) {
  return key === null || key === LOCAL_STORAGE_THEME_MODE_KEY
}

export function getInitialForcedTheme() {
  return THEME_LIGHT_ONLY_PAGE_REG_EXP.test(window.location.pathname)
    ? THEME.light
    : null
}

export function getIsSystemThemeDark() {
  return window.matchMedia(THEME_DARK_MEDIA_QUERY).matches
}

export function getThemeByMode(mode, isSystemDark) {
  const isDark =
    mode === THEME_MODE.dark || (mode === THEME_MODE.system && isSystemDark)

  return isDark ? THEME.dark : THEME.light
}

export function applyTheme(theme) {
  document.documentElement.dataset.theme = theme
}
